// import React, { useState } from 'react';
// import { Box, Typography, Button } from '@mui/material';
// import ContentCopyIcon from '@mui/icons-material/ContentCopy';
// import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

// interface Props {
//     cctm_id: string;
//     isReadOnly?: boolean;
//     onNext: () => void;
// }

// const SNIPPET = `<script>
//   cctag('event', 'add_to_cart', {
//     currency: 'INR',
//     value: 499.00,
//     items: [{
//       item_id: 'YOUR-SKU-001',
//       item_name: 'Product Name',
//       price: 499.00,
//       quantity: 1
//     }]
//   });
// </script>`;

// export const Step2AddToCart: React.FC<Props> = ({ isReadOnly, onNext }) => {
//     const [copied, setCopied] = useState(false);

//     const handleCopy = () => {
//         navigator.clipboard.writeText(SNIPPET);
//         setCopied(true);
//         setTimeout(() => setCopied(false), 2500);
//     };

//     return (
//         <Box>
//             <Typography variant="h6" fontWeight={600} mb={1}>
//                 Step 2 — Track Add to Cart
//             </Typography>
//             <Typography variant="body2" color="text.secondary" mb={3}>
//                 Add this code inside your <strong>"Add to Cart"</strong> button's click handler.
//                 It fires whenever a customer adds a product to their cart.
//             </Typography>

//             <Box
//                 component="pre"
//                 sx={{
//                     bgcolor: '#1e1e1e',
//                     color: '#d4d4d4',
//                     borderRadius: 1.5,
//                     p: 2,
//                     fontSize: '0.75rem',
//                     overflowX: 'auto',
//                     whiteSpace: 'pre',
//                     fontFamily: 'monospace',
//                     mb: 3,
//                 }}
//             >
//                 {SNIPPET}
//             </Box>

//             <Box display="flex" gap={2} flexWrap="wrap">
//                 <Button
//                     variant="outlined"
//                     startIcon={copied ? <CheckCircleOutlineIcon color="success" /> : <ContentCopyIcon />}
//                     onClick={handleCopy}
//                     sx={{ textTransform: 'none' }}
//                 >
//                     {copied ? 'Copied!' : 'Copy Code'}
//                 </Button>
//                 {!isReadOnly && (
//                     <Button variant="contained" onClick={onNext} sx={{ textTransform: 'none' }}>
//                         I've added this → Next
//                     </Button>
//                 )}
//             </Box>
//         </Box>
//     );
// };

import React from 'react';
import {
    Box,
    Typography,
    Button,
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
// import CodeSnippet from '../components/CodeSnippet';
import PlatformSnippetTabs from '../components/PlatformSnippetTabs';
// import { addToCartSnippets } from './platformSnippets';
import { addToCartOptions } from './platformSnippets';

interface Props {
    cctm_id: string;
    pixel?: any;
    platforms?: string[];
    isReadOnly?: boolean;
    onNext: () => void;
    onBack: () => void;
}

// const SNIPPET = `<script>
//   cctag('event', 'add_to_cart', {
//     currency: 'INR',
//     value: 499.00,
//     items: [{
//       item_id: 'YOUR-SKU-001',
//       item_name: 'Product Name',
//       price: 499.00,
//       quantity: 1
//     }]
//   });
// </script>`;

export const Step2AddToCart: React.FC<Props> = ({
    pixel,
    platforms,
    isReadOnly,
    onNext,
    onBack
}) => {
    // const [copied, setCopied] = useState(false);

    // const handleCopy = () => {
    //     navigator.clipboard.writeText(SNIPPET);
    //     setCopied(true);
    //     setTimeout(() => setCopied(false), 2500);
    // };

    return (
        <Box>
            {/* Header */}
            <Box mb={2}>
                <Typography
                    variant="h6"
                    fontWeight={700}
                    mb={1}
                >
                    Step 2 — Track Add To Cart
                </Typography>

                <Typography
                    color="text.secondary"
                    sx={{
                        maxWidth: 700,
                        fontSize: '0.875rem',
                    }}
                >
                    Fire this event whenever a customer adds
                    a product to their shopping cart.
                </Typography>
            </Box>

            {/* Info Card */}
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    p: 2.5,
                    borderRadius: 4,
                    bgcolor: '#EFF6FF',
                    border: '1px solid #BFDBFE',
                    mb: 2,
                }}
            >
                <CheckCircleOutlineIcon
                    sx={{
                        color: '#2563EB',
                        fontSize: 28,
                    }}
                />

                <Box>
                    <Typography fontWeight={700}>
                        Add To Cart Tracking
                    </Typography>

                    <Typography
                        variant="body2"
                        color="text.secondary"
                    >
                        Place this inside your Add To Cart button
                        click handler.
                    </Typography>
                </Box>
            </Box>

            {/* Code Section */}
            <Typography
                variant="subtitle1"
                fontWeight={700}
                mb={1}
            >
                Event Code
            </Typography>

            {/* <CodeSnippet
                title="add-to-cart.js"
                code={SNIPPET}
                copied={copied}
                onCopy={handleCopy}
            /> */}
            {/* <PlatformSnippetTabs
                platforms={platforms}
                snippets={addToCartSnippets(pixel)}
            /> */}
            <PlatformSnippetTabs options={addToCartOptions(pixel)} />

            {/* Footer Actions */}
            {!isReadOnly && (
                <>

                <Box display="flex" gap={2}>
                    <button
        onClick={() => onBack?.()}
        className='btn btn-outline-primary btn-sm'
    >
        ← Back
    </button>
                    <Button
                        variant="contained"
                        onClick={onNext}
                        sx={{
                            borderRadius: 999,
                            px: 4,
                            py: 1.2,
                            fontWeight: 700,
                            textTransform: 'none',
                            background:
                                'linear-gradient(135deg,#2563EB,#7C3AED)',
                            transition: '.25s',

                            '&:hover': {
                                transform: 'translateY(-2px)',
                                background:
                                    'linear-gradient(135deg,#2563EB,#7C3AED)',
                            },
                        }}
                    >
                        I've added this to my site → Next
                    </Button>
                </Box>
                </>
            )}
        </Box>
    );
};